
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../../../service/bc-account-client.service';

export interface ExtensionBillingReason {
	clientID: string;
}

@Component({
	selector: 'app-bc-e-billing-reason',
	templateUrl: './bc-e-billing-reason.component.html',
	styleUrls: ['./bc-e-billing-reason.component.scss'],
	providers: [BcAccountClientService]
})
export class BcEreasonBillingComponent extends DialogComponent<ExtensionBillingReason, any> implements ExtensionBillingReason, OnInit {

	clientID: string;
	private ctcList;
	private ctc;
	private commentary;

	constructor(dialogService: DialogService,
		private bcAccountClientService: BcAccountClientService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCTCByAccountClient();
		this.commentary = 'Segue proposta para sua avaliação.';
	}

	getCTCByAccountClient() {
		this.bcAccountClientService.getCtcByAccountClient(this.clientID).subscribe(result => {
			if (result.Success) {
				this.ctcList = result.Result;

				if (this.ctcList.length === 1) {
					this.ctc = this.ctcList[0].CodigoSap;
				}
			} else {

			}
		}, error => {
			console.log(error);
		});
	}

	confirm() {
		this.result = {
			ctc: this.ctc,
			commentary: this.commentary
		};

		this.close();
	}
}




// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-billing-reason/bc-e-billing-reason.component.ts